import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

const useActiveTab = (key, defaultTab, validTabs = null) => {
  const [searchParams] = useSearchParams();
  const urlTab = searchParams.get('tab');

  const isValidTab = (tab) => {
    if (!validTabs) return true;
    return validTabs.includes(tab);
  };

  const [activeTab, setActiveTabState] = useState(() => {
    if (urlTab && isValidTab(urlTab)) return urlTab;
    try {
      const stored = localStorage.getItem(`activeTab_${key}`);
      if (stored && isValidTab(stored)) {
        return stored;
      }
      return defaultTab;
    } catch (e) {
      return defaultTab;
    }
  });

  // Sync state if URL changes externally
  useEffect(() => {
    if (urlTab && isValidTab(urlTab)) {
      setActiveTabState(urlTab);
      try {
        localStorage.setItem(`activeTab_${key}`, urlTab);
      } catch (e) {
        // Handle error silently
      }
    }
  }, [urlTab, key]);

  const setActiveTab = (tab) => {
    setActiveTabState(prev => {
      const newValue = typeof tab === 'function' ? tab(prev) : tab;
      try {
        localStorage.setItem(`activeTab_${key}`, newValue);
      } catch (e) {
        // Handle error silently
      }
      return newValue;
    });
  };

  return [activeTab, setActiveTab];
};

export default useActiveTab;
